import useTimeout from 'modules/reports/hooks/timeout'
import {useRef} from 'react'

function useDebounce(value: any, callback: Function) {
  const [start, clear] = useTimeout(300, callback)

  const valueRef = useRef(value)
  if (valueRef.current !== value) {
    start()
    valueRef.current = value
  }

  return {clear}
}

export default useDebounce
